import { useState } from "react";

import Button from "./Button";
import Dialog from "./Dialog";
import { invokeConfirmAction } from "~/lib/profession/invokeConfirmAction";

interface ConfirmationModalProps {
	open: boolean;
	onClose: () => void;
	onConfirm: () => void | Promise<void>;
	onCancel?: () => void;
	title: string;
	titleClassName?: string;
	description?: string;
	confirmationLabel?: string;
	cancellationLabel?: string;
	elevated?: boolean;
	children?: React.ReactNode;
}

const ConfirmationModal = ({
	title,
	titleClassName,
	description,
	onClose,
	open,
	onCancel,
	onConfirm,
	confirmationLabel,
	cancellationLabel,
	elevated,
	children,
}: ConfirmationModalProps) => {
	const [isPending, setIsPending] = useState(false);

	return (
		<Dialog
			title={title}
			titleClassName={titleClassName}
			isOpen={open}
			disabled={isPending}
			onClose={onClose}
			elevated={elevated}
			className="max-w-md"
			data-testid="confirmation-modal"
		>
			{description && <p className="my-2 text-center">{description}</p>}

			{children}

			<div className="mt-2 flex flex-1 justify-end gap-4">
				<Button
					disabled={isPending}
					variant="outlined"
					onClick={onCancel ?? onClose}
					className="flex-1 whitespace-nowrap"
				>
					{cancellationLabel || "Cancel"}
				</Button>
				<Button
					disabled={isPending}
					className="flex-1 whitespace-nowrap"
					onClick={() => {
						void invokeConfirmAction(onConfirm, setIsPending);
					}}
				>
					{confirmationLabel || "Confirm"}
				</Button>
			</div>
		</Dialog>
	);
};
export default ConfirmationModal;
